<script setup lang="ts">
import FavoriteProducts from '@/components/about-us/our-family/FavoriteProducts.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header4 from '@/components/base/typography/Header4.vue';

const favoriteProducts = [
  {
    name: 'Power Mix',
    url: '/snacksmixes/power-mix.html',
  },
  {
    name: 'Dried Strawberries',
    url: '/driedfruit/strawberries/dried-strawberries.html',
  },
  {
    name: 'Chocolate Butter Crunch',
    url: '/chocolatessweets/crunches/chocolate-butter.html',
  },
  {
    name: 'Natural Papaya',
    url: '/driedfruit/papaya/natural.html',
  },
  {
    name: 'Dried Organic Mango',
    url: '/driedfruit/mango/organic.html',
  },
  {
    name: 'Ultimate Malted Milk Balls',
    url: '/chocolatessweets/malted-milk-balls/ultimate.html',
  },
  {
    name: 'Caramel Twist',
    url: '/chocolatessweets/caramel/twist.html',
  },
  {
    name: 'White Chocolate Toffee Cashews',
    url: '/nuts/cashews/white-chocolate-toffee.html',
  },
  {
    name: 'Jumbo Gourmet Buttercrunch Mix',
    url: '/chocolatessweets/moregoodies/jumbogourmet-buttercrunch-mix.html',
  },
];
</script>

<template>
  <div>
    <Header4 headerTag="h3">Jeffrey</Header4>
    <BaseBodyText>
      <strong>Hi! I'm Jeff.</strong> Well, everyone here calls me Jeffrey, so you can too. :-
      Although I consider Nuts.com my baby, the real credit goes to my grandfather over 80 years ago
      and then to my dad and uncle of course. Keeping a business in the family, let alone working
      with family, for over 80 years is no small accomplishment, and I am proud and grateful of the
      foundation they have laid.
    </BaseBodyText>
    <BaseBodyText>
      This business certainly runs thick in my veins. I cherish the memories of riding into work on
      my Poppy Sol's lap and going to work with all the grownups. My grandfather was a stoic man,
      and a quiet man, but when he spoke I listened, and he taught me early on the value of hard
      work and of family. Similar to many others of his generation, he was a very strict father, but
      an amazingly loving grandfather. He certainly softened over the years, for no matter how busy
      we were, he would always leave work and take me to get breakfast. My poppy always made me feel
      like a king (not to mention the whopping $5 a day he would pay me). I worshiped him and
      watched in wonder as he continued to come into work every day until 2 weeks before he passed
      away at the age of 88.
    </BaseBodyText>
    <BaseBodyText>
      Growing up in an environment like this hardwired me for business. At the age of 7 I was
      already ringing up the cash register, keeping an eye out for suspicious customers, and
      monitoring how the employees were working (which I would then report back to my father- hehe).
      By 9 I was reading the stock tables to my grandfather, whose eyesight was fading. So, it was
      only natural for me to pursue my studies in business. In my freshman year at college (1999) I
      launched the first version of Nuts.com (NutsOnline). Upon graduating I went to work on Wall
      Street, but after 6 months I was left hungry to do something a lot more fulfilling with my
      life and decided to join the family business full time. I couldn't have been happier with this
      decision. I wake up in the morning excited to go to work. Whereas Sunday evenings were
      depressing for me as a kid because I had to go to school the next day, now Sunday nights are
      no different than any other night. Each day brings new and stimulating challenges as we strive
      to continually improve, satisfy more and more customers, and create a wonderful work
      environment for our employees. My friends might wear fancy suits and have fancy titles, but at
      the end of the day I know that I am carrying on a tradition of bringing smiles to our
      customers' faces. This is a wonderful feeling and means the world to me.
    </BaseBodyText>
    <BaseBodyText>
      If you have anything you want to tell me, whether it be feedback, ideas, or just anything,
      please do not hesitate to
      <a href="mailto:feedback@nuts.com">write me</a>, as I will personally get back to you
      immediately.
    </BaseBodyText>
    <FavoriteProducts :favoriteProducts>
      I love playing soccer, tennis, football, running, biking, and pretty much all other sports,
      reading, traveling, watching movies, and of course, eating. :-)
    </FavoriteProducts>
  </div>
</template>
